import axios from 'axios';
export var ObjectType;
(function (ObjectType) {
    ObjectType["TICKETS"] = "tickets";
    ObjectType["NOTES"] = "notes";
})(ObjectType || (ObjectType = {}));
export default class HubspotAPI {
    constructor() {
        this.apiEndpoint = "https://0ciie10shg.execute-api.us-east-1.amazonaws.com/prod/hubspotticketing";
        this.k = "o83x2mmR9o6kg5xrnc1um4Juj1CmFycv4FIfOPic";
    }
    async sendRequest(method, endpoint, data, objectType = ObjectType.TICKETS) {
        try {
            const response = await axios.post(this.apiEndpoint, JSON.stringify({
                method,
                endpoint,
                data,
                objectType,
            }), {
                headers: {
                    "x-api-key": this.k,
                    "Content-Type": "application/json",
                }
            });
            return response;
        }
        catch (e) {
            console.log("error", e);
        }
    }
    ////// HELPERS //////
    static async getLondonTime() {
        try {
            const response = await axios.get("http://worldtimeapi.org/api/timezone/Europe/London");
            return response.data.datetime || new Date().toISOString();
        }
        catch (e) {
            console.log("error", e);
            return new Date().toISOString();
        }
    }
    static compileContent(title, content, dbId, userEmail, robotSerialNumber, idType = "ticket") {
        const lowerCaseEmail = userEmail.toLowerCase();
        const idString = idType === "ticket" ? "DB ticket id" : "DB note id";
        return `Title: ${title}\n\n${content}\n\nUser email: ${lowerCaseEmail}\nRobot serial number: ${robotSerialNumber}\n${idString}: [[${dbId}]]`;
    }
    static getSerialNumberFromContent(content) {
        const serialNumberRegex = /Robot serial number: ([0-9a-zA-Z]+)/;
        const serialNumberMatch = content.match(serialNumberRegex);
        if (serialNumberMatch && serialNumberMatch[1]) {
            return serialNumberMatch[1];
        }
        return null;
    }
    static getUserEmailFromContent(content) {
        const emailRegex = /User email: ([0-9a-zA-Z@.]+)/;
        const emailMatch = content.match(emailRegex);
        if (emailMatch && emailMatch[1]) {
            return emailMatch[1];
        }
        return null;
    }
    static getTitleFromContent(content) {
        const titleRegex = /Title: ([0-9a-zA-Z@.]+)/;
        const titleMatch = content.match(titleRegex);
        if (titleMatch && titleMatch[1]) {
            return titleMatch[1];
        }
        return null;
    }
    static getLegacyTitleFromContent(content) {
        // first line is the title
        const lines = content.split("\n");
        if (lines && lines.length > 0) {
            return lines[0];
        }
        return null;
    }
    static getDbIdFromContent(content) {
        const dbIdRegex = /DB (ticket|note) id: \[\[([0-9a-zA-Z]+)\]\]/;
        const dbIdMatch = content.match(dbIdRegex);
        if (dbIdMatch && dbIdMatch[2]) {
            return dbIdMatch[2];
        }
        return null;
    }
}
